var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_102_2616)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9978 25.9956C20.1763 25.9956 25.9956 20.1763 25.9956 12.9978C25.9956 5.81926 20.1763 -6.10352e-05 12.9978 -6.10352e-05C5.81932 -6.10352e-05 0 5.81926 0 12.9978C0 20.1763 5.81932 25.9956 12.9978 25.9956Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.68639 5.08441C1.66541 6.41278 0.895538 7.94383 0.447266 9.60709H7.20908L2.68639 5.08441Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5469 9.60704C25.0986 7.94383 24.3287 6.41278 23.3077 5.08441L18.7852 9.60704H25.5469Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.447266 16.3885C0.895589 18.0517 1.66546 19.5828 2.68639 20.9111L7.20892 16.3885H0.447266Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9103 2.68687C19.582 1.66588 18.051 0.896016 16.3877 0.447693V7.20945L20.9103 2.68687Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.08398 23.3086C6.41235 24.3296 7.9434 25.0995 9.60662 25.5478V18.7861L5.08398 23.3086Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.60657 0.447693C7.94335 0.896016 6.4123 1.66588 5.08398 2.68682L9.60657 7.2094V0.447693Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3877 25.5478C18.0509 25.0995 19.582 24.3296 20.9103 23.3087L16.3877 18.7861V25.5478Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7852 16.3885L23.3077 20.9111C24.3287 19.5828 25.0986 18.0517 25.5469 16.3885H18.7852Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8856 11.3025H14.6933H14.6932V0.110086C14.1382 0.037836 13.5724 6.10352e-05 12.9978 6.10352e-05C12.4231 6.10352e-05 11.8574 0.037836 11.3025 0.110086V11.3024V11.3025H0.110025C0.0377749 11.8575 0 12.4233 0 12.9979C0 13.5726 0.0377749 14.1383 0.110025 14.6932H11.3024H11.3024V25.8857C11.8574 25.9579 12.4231 25.9957 12.9978 25.9957C13.5724 25.9957 14.1382 25.958 14.6932 25.8857V14.6933V14.6933H25.8856C25.9579 14.1383 25.9956 13.5726 25.9956 12.9979C25.9956 12.4233 25.9579 11.8575 25.8856 11.3025V11.3025Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3887 16.3886L22.1887 22.1887C22.4555 21.922 22.71 21.6432 22.9528 21.3542L17.9871 16.3885H16.3887V16.3886Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.60677 16.3887H9.60666L3.80664 22.1887C4.0733 22.4555 4.35209 22.7099 4.64109 22.9527L9.60677 17.9869V16.3887Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.60707 9.60723V9.60713L3.807 3.80701C3.54024 4.07367 3.28576 4.35246 3.04297 4.64146L8.00869 9.60718H9.60707V9.60723Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3887 9.60712L22.1888 3.80695C21.9221 3.54019 21.6433 3.28571 21.3543 3.04297L16.3887 8.00869V9.60712Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_102_2616"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.9956,
    height: 25.9956,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUk);
export default __webpack_public_path__ + "static/media/uk.12b920642f722b1de19c85d9fd602c61.svg";
export { ForwardRef as ReactComponent };